import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';

@Injectable()
export class StatService {
  stats = {
    frame_rates: [],
    genres: [],
    types: [],
    resolutions: [],
    styles: []
  };

  constructor(
    private http: Http
  ) { }

  getAll() {
    return Observable.forkJoin(
      this.http.get(`${environment.apiUrl}/admin/frame-rates`).map(this.extractData),
      this.http.get(`${environment.apiUrl}/admin/genres`).map(this.extractData),
      this.http.get(`${environment.apiUrl}/admin/types`).map(this.extractData),
      this.http.get(`${environment.apiUrl}/admin/resolutions`).map(this.extractData),
      this.http.get(`${environment.apiUrl}/admin/styles`).map(this.extractData)
    ).subscribe(([frame_rates, genres, types, resolutions, styles]) => {
      this.stats.frame_rates = frame_rates;
      this.stats.genres = genres;
      this.stats.types = types;
      this.stats.resolutions = resolutions;
      this.stats.styles = styles;
    });
  }

  add(tag, type) {
    if (type === 'frame_rates') {
      tag = {
        rate: tag
      };
    } else {
      tag = {
        name: tag
      };
    }

    return this.http.post(`${environment.apiUrl}/admin/${type}`, tag)
      .map(this.extractData)
      .map(savedTag => {
        this.stats[type].push(savedTag);
        return savedTag;
      });
  }

  delete(id, index: number, type) {
    this.stats[type].splice(index, 1);
    return this.http.delete(`${environment.apiUrl}/admin/${type}/${id}`);
  }

  private extractData(res: Response) {
    let body = res.json();
    return body || [];
  }
}



// WEBPACK FOOTER //
// ./src/app/services/stat.service.ts